export const SETUP_EXPORT = 'SETUP_EXPORT'
export const FLOOR_PLAN_READY = 'FLOOR_PLAN_READY'
export const MAP_READY = 'MAP_READY'
export const CAMERA_MODEL_IMAGE_READY = 'CAMERA_MODEL_IMAGE_READY'
export const UPDATE_EXPORT_TYPE = 'UPDATE_EXPORT_TYPE'
export const SCREENSHOT_CAPTURED = 'SCREENSHOT_CAPTURED'
export const ADD_EXPORT_PROGRESS = 'ADD_EXPORT_PROGRESS'
export const UPDATE_EXPORT_PROGRESS = 'UPDATE_EXPORT_PROGRESS'
export const DESTROY_EXPORT_PROGRESS = 'DESTROY_EXPORT_PROGRESS'
export const START_EXPORT_ACTION = 'START_EXPORT_ACTION'
export const EXPORT_FEEDBACK = 'EXPORT_FEEDBACK'
export const FOV_PREVIEW_READY = 'FOV_PREVIEW_READY'
export const CLEAR_FOV_PREVIEW_READY = 'CLEAR_FOV_PREVIEW_READY'
export const NETWORK_CLOSET_LIST_READY = 'NETWORK_CLOSET_LIST_READY'
export const SET_NETWORK_CLOSET_LIST_PAGES = 'SET_NETWORK_CLOSET_LIST_PAGES'



// WEBPACK FOOTER //
// ./src/actions/exportActionTypes.js